import "./AdminRequest.scss";
import Request from "../../components/Request/Request";

import { useState, useEffect } from "react";
import { API_URL } from "../../utils/axios";
import axios from "axios";

const AdminRequest = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAll = () => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;

    axios
      .get(API_URL + "/order")
      .then((response) => {
        setRequests(response.data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  };
  const handleDelete = (id) => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
    axios
      .delete(API_URL + "/order/" + id)
      .then(() => {
        fetchAll();
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchAll();
  }, []);

  return (
    <div>
      {!loading && <Request requests={requests} handleDelete={handleDelete} />}
    </div>
  );
};

export default AdminRequest;
